import { useMemo } from 'react';

import Notification from '../Notification';
import AlertsStack, { IAlert } from 'components/alerts/AlertsStack';

import { groupByType } from '../../utils/group';
import useNotificationMessages from '../../hooks/common/useNotificationMessages';

import { INotificationsGroupProps } from './NotificationsGroup.types';
import { NotificationType } from 'types/internalNotifications';

const NotificationsGroup = ({ data, onDelete }: INotificationsGroupProps) => {
  const messages = useNotificationMessages();

  const dataGroupedByType = useMemo(() => groupByType(data), [data]);

  const closableNotifications = dataGroupedByType[NotificationType.CLOSABLE] || [];
  const notClosableNotifications = dataGroupedByType[NotificationType.NOT_CLOSABLE] || [];

  const closableAlerts: IAlert[] = closableNotifications.map(item => ({
    id: item.id,
    type: 'warning',
    message: messages[item.msg] || item.msg,
  }));

  return (
    <>
      {notClosableNotifications.map(notification => (
        <Notification key={notification.id} data={notification} onDelete={onDelete} />
      ))}

      {!!closableNotifications.length && <AlertsStack alerts={closableAlerts} onDelete={onDelete} />}
    </>
  );
};

export default NotificationsGroup;
